import React, { useState } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Portal,
} from "@chakra-ui/react";
import { TbShoppingBagX } from "react-icons/tb";
// import PropTypes from "prop-types";

const CustomizationTooltip = ({
  modifierGroupText,
  customizationName,
  options,
  sold_out,
  placement = "top",
  customization,
  onCustomizationClick,
  children,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    if (!disabled) {
      setIsOpen(true);
    }
  };
  const handleClose = () => setIsOpen(false);

  return (
    <Popover
      isOpen={disabled ? false : isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      placement={placement}
      trigger={disabled ? "click" : "hover"}
      isLazy
    >
      <PopoverTrigger>
        <Box display="inline-flex" alignItems="center" onClick={handleOpen} onMouseEnter={disabled ? undefined : handleOpen}>
          {children}
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          zIndex={9999}
          bg="gray.100"
          color="black"
          fontSize="sm"
          p={3}
          borderRadius="md"
        >
          <PopoverArrow />
          <PopoverBody>
            {/* Modifier Group Text */}
            <Text fontWeight="bold" mb={1}>
              {modifierGroupText}
            </Text>

            {/* Customization Name */}
            <HStack width="100%" justifyContent="space-between">
              <Text mb={2}>{customizationName}</Text>
              {sold_out && <TbShoppingBagX color="red" size={16} />}
            </HStack>

            {/* Options List */}
            {options && options.length > 0 ? (
              <VStack align="start" spacing={0}>
                {options.sort((a, b) => {
                  // Sort by sequence_number to maintain drag and drop order
                  return (a.sequence_number || 0) - (b.sequence_number || 0);
                }).map((option, index) => (
                  <Flex key={option.id || index} fontSize="sm"
                     justify="space-between"
                     cursor={"pointer"}
                     _hover={{fontWeight:"bold"}}
                     onClick={() => {
                      onCustomizationClick(customization.id, customization)
                    }}
                     >
                    <Text>{option.option}</Text>:
                    <HStack paddingLeft={1}>
                      <Text>${(Number(option.price) || 0).toFixed(2)}</Text>
                      {option.sold_out && <TbShoppingBagX color="red" size={16} />}
                    </HStack>
                  </Flex>
                ))}
              </VStack>
            ) : (
              <Text fontSize="sm" color="gray.500">
                No options available
              </Text>
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};


export default CustomizationTooltip;
